import "./404.58cfd041.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea80d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea80d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5QDZi", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $4420d3cf14c8511c$export$4bd44a2aa29d3d6e; });
$parcel$export(module.exports, "genRandStr", function () { return $4420d3cf14c8511c$export$9523f26048d69498; });
// UTILITAIRES EN VRAC
function $4420d3cf14c8511c$export$4bd44a2aa29d3d6e() {
    switch(location.hostname){
        case 'vitroto.fr':
        case 'www.vitroto.fr':
        case 'vps-ee7fed3b.vps.ovh.net':
            return 'prod';
        case 'dev.vitroto.fr':
        case 'test.vitroto.fr':
        case 'vps235287.ovh.net':
            return 'dev';
        default:
            throw 'utils.getEnv(): check hostname: ' + location.hostname;
    }
}
function $4420d3cf14c8511c$export$9523f26048d69498(len) {
    // Timestamp's based for ordering
    len = len || 40;
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var text = '';
    for(var i = 0; i < len; i++)text += chars.charAt(Math.floor(Math.random() * chars.length));
    // Ou:
    //text = Math.random().toString(36).substr(2,11);	    // 10 ou 11 chars
    return text;
}
function $4420d3cf14c8511c$export$1c66a7c513d1624(str) {
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}
function $4420d3cf14c8511c$export$61fc7d43ac8f84b0(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
function $4420d3cf14c8511c$export$529f52b70a3feab9(array, key, sens, lowercase) {
    sens = sens || 'asc';
    lowercase = lowercase || false;
    var length = array.length - 1, done, i, j;
    for(i = 0; i < length; i++){
        done = true;
        for(j = 0; j < length; j++){
            var item1 = array[j], item2 = array[j + 1];
            var value1 = item1[key], value2 = item2[key];
            if (lowercase) {
                value1 = value1.toLowerCase();
                value2 = value2.toLowerCase();
            }
            if (sens === 'asc' && value1 > value2 || sens === 'desc' && value1 < value2) {
                array[j] = item2;
                array[j + 1] = item1;
                done = false;
            }
        }
        if (done) break;
    }
}
function $4420d3cf14c8511c$export$4cf11838cdc2a8a8(html) {
    var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '/': '&#x2F;'
    };
    var htmlEscaper = /[&<>"'\/]/g;
    return ('' + html).replace(htmlEscaper, function(match) {
        return htmlEscapes[match];
    });
}
function $4420d3cf14c8511c$export$54c55c906b2ca7e5(el) {
    if (typeof el.selectionStart == "number") el.selectionStart = el.selectionEnd = el.value.length;
    else if (typeof el.createTextRange != "undefined") {
        el.focus();
        var range = el.createTextRange();
        range.collapse(false);
        range.select();
    }
}
function $4420d3cf14c8511c$export$a6cdc56e425d0d0a(o) {
    return [
        'object',
        'function'
    ].includes(typeof o) && o !== null;
}

});

parcelRequire("a0S24");

var $5QDZi = parcelRequire("5QDZi");

var $k8PoE = parcelRequire("k8PoE");

var $kNNyJ = parcelRequire("kNNyJ");
const $2be07f53fa3dfe01$var$debug = (0, $5QDZi.getEnv)() === 'dev';
const $2be07f53fa3dfe01$var$main_form = document.getElementById('main-form');
if ($2be07f53fa3dfe01$var$debug) {
    document.getElementById('nom').value = 'Nom du responsable';
    document.getElementById('prenom').value = "Pr\xe9nom du responsable";
    document.getElementById('tel').value = '+3378544564646';
    document.getElementById('email').value = 'email_responsable_' + (0, $5QDZi.genRandStr)(2) + '@gmail.com';
    document.getElementById('pwd1').value = "FNvNIGG3/kZSS9lVld/l";
    document.getElementById('pwd2').value = "FNvNIGG3/kZSS9lVld/l";
    document.getElementById('nom_agence-0').value = "Nom de l'agence";
    document.getElementById('tel_agence-0').value = "+3364566865346";
    document.getElementById('adresse-0').value = "R\xe9sidence les lilas\n14 Ave d'Avienne";
    document.getElementById('ville-0').value = "Toulon";
    document.getElementById('code_postal-0').value = "83000";
    document.getElementById('pays-0').value = "FR";
    document.getElementById('email-0').value = "email_agence_" + (0, $5QDZi.genRandStr)(2) + "@gmail.com";
    document.getElementById('pwd1-0').value = "FNvNIGG3/kZSS9lVld/l";
    document.getElementById('pwd2-0').value = "FNvNIGG3/kZSS9lVld/l";
}
document.getElementById('add-agence').addEventListener('click', function(e) {
    // Simple clone
    const clone = document.getElementsByClassName('agence-data')[0].cloneNode(true);
    const i = (0, $5QDZi.genRandStr)(6);
    [
        'email_code',
        'id_franchise',
        'nom_agence',
        'tel_agence',
        'adresse',
        'code_postal',
        'ville',
        'pays',
        'email',
        'pwd1',
        'pwd2'
    ].forEach((key)=>{
        clone.querySelector('.' + key + ' label').htmlFor = key + '-' + i;
        const tag = {
            id_franchise: 'select',
            adresse: 'textarea',
            pays: 'select'
        }[key] || 'input';
        const input = clone.querySelector('.' + key + ' ' + tag);
        input.id = key + '-' + i;
        const value = $2be07f53fa3dfe01$var$debug ? input.value + (key === 'email' ? (0, $5QDZi.genRandStr)(3) : '') : '';
        input.value = key === 'id_franchise' ? '1' : value;
    });
    document.getElementById('agences-data').appendChild(clone);
    clone.scrollIntoView({
        block: 'center'
    });
    $2be07f53fa3dfe01$var$handleTagNames();
});
document.getElementById('agences-data').addEventListener('click', async function(e) {
    const btn = e.target.closest('.del-agence');
    if (btn) {
        await (0, $kNNyJ.fadeOutRemove)(e.target.closest('.agence-data'));
        $2be07f53fa3dfe01$var$handleTagNames();
    }
});
$2be07f53fa3dfe01$var$main_form.addEventListener('submit', function(e) {
    e.preventDefault();
    // Submit depuis le form principal, on n'envoie pas d'éventuelles valeurs antérieures email_code
    this.querySelectorAll('input.email_code').forEach((input)=>input.value = '');
    $2be07f53fa3dfe01$var$submit.call(this);
});
async function $2be07f53fa3dfe01$var$submit() {
    const form_data = new FormData(this);
    // Gestion erreur si email identique indiqué plusieurs fois
    const emails = {};
    emails[form_data.get('email').trim().toLowerCase()] = true; // responsable
    // Pour les agences, plus simple d'aller piocher dans le DOM
    for (const input of document.querySelectorAll('#agences-data .email input')){
        const email = input.value.trim().toLowerCase();
        if (emails[email]) {
            (0, $kNNyJ.showMessages)(`<b>Erreur: il n'est pas permis d'utiliser le m\xeame email plusieurs fois dans le formulaire.</b><br>
		Veuillez corriger votre saisie: "${email}".`);
            return;
        }
        emails[email] = true;
    }
    // Vérification si les différents passwords correspondent
    // Responsable
    const pwd1 = form_data.get('pwd1'), pwd2 = form_data.get('pwd2');
    let err = false;
    if (pwd1 !== pwd2) {
        document.getElementById('pwd2').setCustomValidity('Les mots de passe ne correspondent pas');
        err = true;
    }
    // Agences
    for (const cont of document.querySelectorAll('#agences-data .pwd-container')){
        const pwd1 = cont.querySelector('.pwd1 input'), pwd2 = cont.querySelector('.pwd2 input');
        if (pwd1.value !== pwd2.value) {
            pwd2.setCustomValidity('Les mots de passe ne correspondent pas');
            err = true;
        }
    }
    if (err) {
        (0, $kNNyJ.showMessages)("Veuillez v\xe9rifier que les mots de passe indiqu\xe9s soient identiques");
        return;
    }
    form_data.append('a', 'signup');
    const json = await (0, $k8PoE.post)(form_data, {
        auth: false,
        return_all: true,
        msg_success: 'silent'
    });
    // response = "": succès (en attente de validation par admin) et on gère ici le message afin de le mettre dans alert_success
    // response = "email_code" (emails envoyés, affichage popup, user doit entrer les codes correspondants) et json.msg défini
    if (json.data === 'email_code') {
        $2be07f53fa3dfe01$var$showPopupEmailCode();
        (0, $kNNyJ.showMessages)(json.msg);
    } else {
        this.classList.remove('was-validated');
        this.reset();
        (0, $kNNyJ.showAlert)('success', "Votre compte a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s.<br>Vous allez recevoir un email de confirmation.<br>Votre acc\xe8s ne sera pleinement op\xe9rationnel qu'une fois qu'un administrateur vitroto aura valid\xe9 votre demande et vous recevrez alors un 2\xe8me email.", 'scroll');
    }
}
// Gestion password identiques, event par délégation
$2be07f53fa3dfe01$var$main_form.addEventListener('input', function(e) {
    const t = e.target;
    if (t.tagName !== 'INPUT' || !t.classList.contains('pwd')) return;
    const cont = t.closest('.pwd-container'), pwd1 = cont.querySelector('.pwd1 input'), pwd2 = cont.querySelector('.pwd2 input');
    if (pwd2.validity.customError && pwd1.value === pwd2.value) pwd2.setCustomValidity('');
});
// #############
// HELPERS
// #############
function $2be07f53fa3dfe01$var$showPopupEmailCode() {
    if ($2be07f53fa3dfe01$var$showPopupEmailCode.popup === null) {
        // 1: Au 1er appel, générer le popup, mais sans body qui peut être variable selon le nombre d'agences
        const p = $2be07f53fa3dfe01$var$showPopupEmailCode.popup = (0, $kNNyJ.Popup).get('popup-email-code', {
            backdrop: 'static',
            size: 'lg',
            html_header: "<h3>Validation des emails</h3>",
            html_footer: '<button form="form-email-code" class="btn btn-primary">Soumettre</button>'
        });
        p.setEvents([
            {
                selector: null,
                type: 'submit',
                listener: async function(e) {
                    const form = e.target;
                    if (form.tagName !== 'FORM') return;
                    e.preventDefault();
                    // Copie des codes vers le form d'origine qui en seront supprimés au prochain submit depuis main_form
                    form.querySelectorAll('input[name="email_code"]').forEach((input)=>{
                        $2be07f53fa3dfe01$var$main_form.querySelector(input.dataset.selector).value = input.value;
                    });
                    await $2be07f53fa3dfe01$var$submit.call($2be07f53fa3dfe01$var$main_form);
                    p.hide();
                }
            }
        ]);
    }
    const p = $2be07f53fa3dfe01$var$showPopupEmailCode.popup;
    // 2: mise en place du body
    p.setBody($2be07f53fa3dfe01$var$getPopupBody());
    // 3: reset
    p.findAll('input[name="email_code"]').forEach((input)=>input.value = '');
    document.getElementById('form-email-code').classList.remove('was-validated'); // Retirer id du form, changer selecteur
    // 4: Go !
    p.show();
}
$2be07f53fa3dfe01$var$showPopupEmailCode.popup = null;
function $2be07f53fa3dfe01$var$getPopupBody() {
    // Détaché de showPopupEmailCode() uniquement pour plus de clarté
    // Pour chaque input email_code de main_form (1 pour responsable, 1 pour chaque agence):
    // - insertion input dans popup
    // - cet input conserve le selecteur pour update main_form plus simple
    // 1: responsable
    const email = document.getElementById('email').value;
    let body = `<form id="form-email-code" class="needs-validation" novalidate style="overflow-y: auto; max-height: 25rem;">
	<h3 class="h6">Merci de renseigner les codes \xe0 6 chiffres que vous allez recevoir \xe0 chacun des emails utilis\xe9s</h3>
	<hr>
	<ul>
	    <li class="mb-3">
		<label class="mb-2 align-top" for="email_code">Code pour le <u>responsable d'agence(s)</u>: \xab&nbsp;<i>${email}</i>&nbsp;\xbb</label>
		<input type="text" id="email_code" name="email_code" inputmode="numeric" class="form-control w-auto m-auto" required minlength="6" maxlength="6" pattern="\\d*" autocomplete="one-time-code" data-selector="input[name=email_code]">
		<div class="invalid-feedback">Veuillez indiquer un code \xe0 6 chiffres</div>
	    </li>`;
    // 2: agences
    $2be07f53fa3dfe01$var$main_form.querySelectorAll('.agence-data').forEach((agence, i)=>{
        const email = agence.querySelector('.email input').value;
        const id = 'email_code-' + (0, $5QDZi.genRandStr)(6); // Ou équivalent: "email_code{$i}"
        body += `<li class="mb-3">
	    <label class="mb-2 align-top" for="${id}">Code pour <u>l'agence</u>: \xab&nbsp;<i>${email}</i>&nbsp;\xbb</label>
	    <input type="text" id="${id}" name="email_code" inputmode="numeric" class="form-control w-auto m-auto" required minlength="6" maxlength="6" pattern="\\d*" autocomplete="one-time-code" data-selector='input[name="agences[${i}][email_code]"]'>
	    <div class="invalid-feedback">Veuillez indiquer un code \xe0 6 chiffres</div>
	</li>`;
    });
    body += '</ul></form>';
    return body;
}
// Réorganiser les attributs name des inputs à l'ajout - delete, afin de recevoir ça groupé par agences sur le serveur
// ie: 1ère agence: name="agences[0][name]", 2ème agence: name="agences[1][name]" etc.
const $2be07f53fa3dfe01$var$handleTagNames = ()=>{
    document.querySelectorAll('.agence-data').forEach((el, i)=>{
        [
            'email_code',
            'id_franchise',
            'nom_agence',
            'tel_agence',
            'adresse',
            'code_postal',
            'ville',
            'pays',
            'email',
            'pwd1',
            'pwd2'
        ].forEach((key)=>{
            const tag = {
                id_franchise: 'select',
                adresse: 'textarea',
                pays: 'select'
            }[key] || 'input';
            el.querySelector('.' + key + ' ' + tag).name = 'agences[' + i + '][' + key + ']';
        });
    });
};


//# sourceMappingURL=inscription.2a4dc4f9.js.map
